import React, { useState, useMemo } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material'
import {
  Search as SearchIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Business,
} from '@mui/icons-material'
import { RoleListAPI } from '../../Conections/RolesAndPermissionsConection';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';


const initialData = [
  { id: 0, name: '', description: '' },
]

export default function ListRoles() {

  const auth = useAuth();
  const goTo = useNavigate();

  const [data, setData] = useState(initialData);
  const [sortConfig, setSortConfig] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [permitido, setPermitido] = React.useState(false);
  const [permitidoP, setPermitidoP] = React.useState(false);
  const [permitidoShow, setPermitidoShow] = React.useState(false);


  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (auth.getToken()) {
      const permisionCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/listroles");
      if (permisionCan) {
        const datos = await RoleListAPI(auth.getToken(), auth.getCompany());
        if (typeof datos[0] === "number") {
          setPermitido(false);
        } else {
          const permisionShowCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/showrole/:id");
          setPermitidoP(permisionCan);
          setPermitidoShow(permisionShowCan);
          setPermitido(true);
          setData(datos);
        }
      }
      else {
        goTo("/dashboard");
      }
    }
    else {
      goTo("/login");
    }
  }

  const sortData = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  const sortedAndFilteredData = useMemo(() => {
    let sortableData = [...data]
    if (searchTerm) {
      sortableData = sortableData.filter(
        item =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.phone.includes(searchTerm) ||
          item.address.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    return sortableData
  }, [data, sortConfig, searchTerm])


  const show = ((id) => (
    permitidoP && (
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        {
          permitidoShow ? (
            <Button
              startIcon={<Business />}
              onClick={() => goTo(`/dashboard/rpp/showrole/${id}`)}
              sx={{ mr: 1 }}
            >
              Show
            </Button>
          ) : (
            <></>
          )
        }
      </Box>
    )
  )
  );

  return (
    permitido ? (
      <Paper sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 3, flexGrow: 0 }}>
          <Typography variant="h4" gutterBottom color="primary">
            List Roles
          </Typography>
        </Box>
        <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'flex-end' }}>
            <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
            <TextField
              label="Buscar"
              variant="standard"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              fullWidth
            />
          </Box>
          <TableContainer component={Paper} sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {['name', 'description'].map((key) => (
                    <TableCell
                      key={key}
                      onClick={() => sortData(key)}
                      sx={{ cursor: 'pointer' }}
                    >
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {sortConfig?.key === key && (
                        sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedAndFilteredData.map((person) => (
                  <TableRow
                    key={person.id}
                    onClick={() => setSelectedPerson(person)}
                    selected={selectedPerson?.id === person.id}
                    hover
                  >
                    <TableCell>{person.name}</TableCell>
                    <TableCell>{person.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/*selectedPerson && (
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                startIcon={<Business />}
                onClick={() => goTo(`/dashboard/rpp/showrole/${selectedPerson.id}`)}
                sx={{ mr: 1 }}
              >
                Show
              </Button>
            </Box>
          )*/}
          {
            selectedPerson && show(selectedPerson.id)
          }
        </Box>
      </Paper>
    ) : (
      <ErrorCard />
    )
  )
}